import React from 'react';
import { Button, Illustration } from '@saviynt/design-system';

import { useInvertedLocalize } from '../../../utilities';
import { P } from '../../utilities';

import { invertedMessages } from './messages';

import './MfaError.css';

interface MfaErrorProps {
  onRetry?: () => void;
}

MfaError.defaultProps = {
  onRetry: undefined,
};

/**
 * View component that renders an error message and a retry button.
 */
export default function MfaError({ onRetry: handleClick }: MfaErrorProps) {
  const l = useInvertedLocalize(invertedMessages);

  return (
    <div className='Nav_MfaError'>
      <Illustration kind='error' />
      <P className='Nav_MfaError-message'>
        {l(
          "Sorry, we're having trouble loading the content. Please try reloading the page, or check your internet connection. If the issue persists, contact support."
        )}
      </P>
      {handleClick && (
        <Button size='large' onClick={handleClick}>
          Reload
        </Button>
      )}
    </div>
  );
}
